import { GcpRequestData, useUploadStore } from '../../../../../../store/uploadStore';
import { Customer, Site } from '../../../../../../types';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { recalcGcpStats } from '../gcpRequestUploadFiles/useHandleGcpFileUpload';

export const useDiscardGcpChanges = (customer: Customer, site: Site, gcpRequest?: GcpRequestData) => {
  const { setGcpRequest } = useUploadStore();

  return () => {
    if (!gcpRequest) return;
    gcpRequest.meta.isEditMode = gcpRequest.meta.prevMeasurements.length === 0;

    trackAction('Discard GCP Request changes', { customer, site });

    gcpRequest.measurements = gcpRequest.meta.prevMeasurements.concat();
    gcpRequest.photos = gcpRequest.meta.prevPhotos.concat();
    gcpRequest.comment = gcpRequest.meta.prevComment;
    gcpRequest.measurementUploads = gcpRequest.meta.prevMeasurementUploads.concat();
    gcpRequest.photoUploads = gcpRequest.meta.prevPhotoUploads.concat();
    gcpRequest.autoGcpServiceLaborTimeInHours = undefined;
    recalcGcpStats(gcpRequest);
    gcpRequest.gcpServiceLaborTimeInHours = gcpRequest.meta.prevGcpServiceLaborTimeInHours;

    setGcpRequest(customer.id, site.id, gcpRequest);
  };
};
